<template>
    <div class="dialog-table-container">
        <span class="dialog-title">以下为可选项目，请选择并开始提交审批：</span>
        <avue-crud
            :option="option"
            :data="tableData"
            ref="crud"
            :page.sync="page"
            :search.sync="queryList"
            v-model="form"
            :before-open="beforeOpenScope"
            @on-load="queryList"
            @search-change="searchChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
        >
        </avue-crud>
        <div class="bottom-line">
            <el-button plain @click="cancelDialog" size="small">取消</el-button>
            <el-button type="primary" @click="goNext" size="small">下一步</el-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as api from "@/api/zd/project";
export default {
    name: 'DialogTable',
    data() {
        return {
            tableData: [],
            selectionList: [],
            option: {
                menu: false,
                align: "center",
                card: true,
                columnBtn: false,
                searchBtn: true,
                refreshBtn:false,
                tip: false,
                simplePage: true,
                searchMenuSpan: 6,
                tree: true,
                editBtn: false,
                addBtn: false,
                delBtn: false,
                labelWidth: 100,
                selection: true,
                selectionWidth: 45,
                searchShow: false,
                column: [
                    {
                        label: "项目名称",
                        prop: "name",
                        fixed: true,
                        width:240,
                        overHidden: true
                    },{
                        label: "项目编号",
                        prop: "number",
                        fixed: true,
                        filterable: false,
                        width:120
                    },{
                        label: "客户名称",
                        prop: "custName",
                        // type: "select",
                        // filterable:'true' ,
                        // dicUrl: "/api/blade-/zd/custom/getListDefault",
                        // dicMethod: "post",
                        // dicQuery: {},
                        // props: {
                        // label: "custName",
                        // value: "id",
                        // },
                        // dataType: "string",
                        display: true,
                        width:200,
                    },{
                        label: "申请银行",
                        prop: "bankName",
                        width:150
                    },{
                        sortable: "custom",
                        label: "贷款到期金额",
                        prop: "expireQuota",
                        width:120,
                        formatter: (row, value, label, column) => {
                            return this.getMoney(value)
                        }
                    },{
                        sortable: "custom",
                        label: "申请转贷金额",
                        prop: "quota",
                        width:120,
                        formatter: (row, value, label, column) => {
                            return this.getMoney(value)   
                        }
                    },{
                        label: "使用费率",
                        prop: "loanRate",
                        formatter: (row, value, label, column) => {
                            if (value == -1) {
                                return "-";
                            } else {
                                return `${Number(value)*100}%`
                            }
                        }
                    },
                ]
            },
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background: false,
                pageSize: 10,
            },
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    mounted() {

    },
    methods: {
        selectionChange(files) {
            this.selectionList = files
        },
        goNext() {
            if(this.selectionList.length > 0) {
                this.$emit('goNext', this.selectionList)
            }else {
                this.$message.warning('请选择项目后再执行下一步')
            }
        },
        cancelDialog() {
            this.$emit('cancelDialog')
        },
        queryList() {
            api.getListProject({
                firstNum: (this.page.currentPage - 1) * this.page.pageSize,
                num: this.page.pageSize,
                managerUser: this.userInfo.user_id,
                auditStatus: '0',
                isBatch: 1
            }).then((res) => {
                this.page.total = res.data.data.total;
                this.tableData = res.data.data.list;
            })
            .catch((res) => {
            
            });
        },

        clearList() {
            this.selectionList = []
        }
    }
}
</script>
<style lang="scss" scoped>
.dialog-table-container{
    .dialog-title{
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #666666;
        text-align: right;
        line-height: 28px;        
    }  
    .bottom-line{
        width: 100%;
        border-top: 1px solid #f0f0f0;
        /* float: right; */
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
    }
    /deep/ .avue-crud__menu {
        min-height: 0 !important;
    }
}

</style>